module.exports = __webpack_public_path__ + "10c94890332deac82a41c11429b1a33e.MP3";